var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlbumWeb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "12px",
    viewBox: "0 0 17 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAlbumWeb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAlbumWeb"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#535453",
    strokeWidth: 0.7,
    x: 0.35,
    y: 0.35,
    width: 16.3,
    height: 11.262963,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(8.814815, 5.666667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.629630)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    points: "3.20190658 0 6.78248535 2.84406252 2.96610391 2.84406252 0.20672464 2.84406252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mountain",
    stroke: "#535453",
    strokeLinecap: "square",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.216435185,2.97325103 L3.24652778,0.174897119",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24652778,0.174897119 L6.70949074,2.97325103",
    id: "Line-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.259259, 3.777778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.692593)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    points: "4.94840108 0 10.4820228 5.63124379 4.58397878 5.63124379 0.319483534 5.63124379"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mountain",
    stroke: "#535453",
    strokeLinecap: "square",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.334490741,5.88703704 L5.01736111,0.346296296",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01736111,0.346296296 L10.369213,5.88703704",
    id: "Line-3"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#535453",
    strokeWidth: 0.7,
    fill: "#FFFFFF",
    cx: 10.3888889,
    cy: 2.83333333,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlbumWeb);
export default __webpack_public_path__ + "static/media/icAlbumWeb.db950e0010f067223f2e9c85fed8b3b3.svg";
export { ForwardRef as ReactComponent };